import { render } from "./UpdateDetails.vue?vue&type=template&id=39d2b5aa&scoped=true"
import script from "./UpdateDetails.vue?vue&type=script&lang=js"
export * from "./UpdateDetails.vue?vue&type=script&lang=js"

import "./UpdateDetails.vue?vue&type=style&index=0&id=39d2b5aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2b5aa"]])

export default __exports__